import {useEffect, useRef, type ReactNode} from "react";
import {Modal} from "@mantine/core";
import {useLocation} from "react-router-dom";
import {
    ChecklistModalActions,
    type PrimaryConfig,
    type SecondaryConfig,
} from "./ChecklistModalActions";
import classes from "./modalStyles.module.css";

type ChecklistModalProps = {
    opened: boolean;
    onClose: () => void;
    title: ReactNode;
    children: ReactNode;
    size?: string;
    primary?: PrimaryConfig;
    secondary?: SecondaryConfig;
};

export const ChecklistModal = ({
    opened,
    onClose,
    title,
    children,
    size = "32rem",
    primary,
    secondary,
}: ChecklistModalProps) => {
    const location = useLocation();
    const prev = useRef(location);

    useEffect(() => {
        if (prev.current !== location) {
            prev.current = location;
            if (opened) onClose();
        }
    }, [location, opened, onClose]);

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title={title}
            size={size}
            classNames={{title: classes.modalTitle}}
        >
            {children}
            {(primary || secondary) && (
                <ChecklistModalActions
                    primary={primary}
                    secondary={secondary}
                />
            )}
        </Modal>
    );
};
